import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';
import auth from './auth'
import project from './project'
import uiPreferences from './uiPreferences'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    project,
    uiPreferences
  },
  plugins: [vuexLocal.plugin]
})